import {UserEvent} from './UserEvent';

export class UserFlaggedAsActive extends UserEvent {}
